// extracted by mini-css-extract-plugin
export default {"modalButtonArea":"ViewPopup_modalButtonArea__xNFhZ","moduleHeaderArea":"ViewPopup_moduleHeaderArea__cMd4+","disbaleBtn":"ViewPopup_disbaleBtn__+2XZL"};